import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CustomersUriService } from './customers-uri.service';
import { CustomerFinanceSummary, CascadeSellInvoiceItem, CascadeSellInvoiceList, CascadeInvoice, InvoiceRelatedOrders, DefaultList } from '../models/customers.model';
import { PriceLists, CustomerShowingPrice } from '../models/price-list.model';
import { Currency } from 'src/app/shared/models/currency.model';
import { Category } from 'src/app/shared/models/category.model';
import { Price } from '../models/price.model';
import { ExportPrice } from '../models/export-price.model';
import { WalletList, walletFilters, CascadeSellInvoiceFilters } from '../models/wallet-list.model';
import { Credit } from '../models/credit.model';
import { payLoad } from '../models/payload.model';
import { WalletStatistic } from '../models/wallet-statistic.model';
import { CustomerRegister, CustomerRegisterByCode } from '../models/customer-register.model';
import { DefaultPriceListItem, DefaultPriceList, DefaultPriceListEntity } from '../models/default-price-list.model';
import { Profile } from 'src/app/core/models/initials.model';
import { AssignedProductListResults } from '../models/assigned-product-list.model';
import { AssignedProductListByPercent } from "../models/assigned-product-list-by-percent.model";
import { ProductSuggestions, DisplayPrice } from "../models/display-products.model";
import { PaginationFilter } from "../../dashboard/models/pin-filter.model";
import { MyMerchantList } from "src/app/core/models/initials.model";
import { Login } from "src/app/core/models/Login.model";

@Injectable({ providedIn: 'root' })

export class CustomersGatewayService {
  constructor(private customersUriService: CustomersUriService, private http: HttpClient) { }

  getUserPriceList(userId: number): Observable<PriceLists> {
    let params = new HttpParams();
    params = params.append('to_user', userId.toString());

    const url = this.customersUriService.getUserPriceListUri();
    return this.http.get<PriceLists>(url, { params })
  }

  getUserPriceListByPercent(userId: number, filters?): Observable<AssignedProductListByPercent> {
    let params = new HttpParams();
    params = params.append('to_user', userId.toString());

    for (const filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    // if (limit) params = params.append('limit', limit.toString());
    // if (offset) params = params.append('offset', offset.toString());

    const url = this.customersUriService.getUserPriceListByPercentUri();
    return this.http.get<AssignedProductListByPercent>(url, { params })
  }

  getUserAssignPercent(filters): Observable<any> {
    let params = new HttpParams();

    for (const filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.customersUriService.getUserAssignPercentUri();
    return this.http.get<any>(url, {params})
  }

  getCustomerAssignPercent(filters): Observable<any> {
    let params = new HttpParams();

    for (const filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.customersUriService.getCustomerAssignPercentUri();
    return this.http.get<any>(url, {params})
  }

  getDefaultPriceListDetails(id: number): Observable<DefaultPriceListEntity[]> {
    const url = this.customersUriService.getDefaultPriceListDetailsUri(id);
    return this.http.get<DefaultPriceListEntity[]>(url);
  }

  getDefaultPriceListByPercentDetails(id: number, filters): Observable<any> {
    let params = new HttpParams();

    for (let filter in filters) {
      params = params.append(filter, filters[filter]);
    }

    const url = this.customersUriService.getDefaultPriceListDetailsByPercentUri(id);
    return this.http.get<any[]>(url, { params });
  }

  getDefaultPriceListInfo(id: number): Observable<DefaultPriceListItem> {
    const url = this.customersUriService.getDefaultPriceListInfoUri(id);
    return this.http.get<DefaultPriceListItem>(url);
  }

  getDefaultPriceListByPercentInfo(id: number): Observable<any> {
    const url = this.customersUriService.getDefaultPriceListByPercentInfoUri(id);
    return this.http.get<any>(url);
  }

  getDefaultPriceList(filters: Object) {
    let params = new HttpParams();
    for (let filter in filters) {
      params = params.append(filter, filters[filter]);
    }
    const url = this.customersUriService.getDefaultPriceListUri();
    return this.http.get<DefaultPriceList>(url, { params });
  }

  getDefaultPriceListByPercent(filters: Object) {
    let params = new HttpParams();
    for (let filter in filters) {
      params = params.append(filter, filters[filter]);
    }
    const url = this.customersUriService.getDefaultPriceListByPercentUri();
    return this.http.get<any>(url, { params });
  }

  addDefaultPriceList(name: string) {
    let data = {
      title: name
    }

    const url = this.customersUriService.getDefaultPriceListUri();
    return this.http.post<DefaultList>(url, data);
  }

  addDefaultPriceListByPercent(name: string) {
    let data = {
      title: name
    }

    const url = this.customersUriService.getDefaultPriceListByPercentUri();
    return this.http.post<any>(url, data);
  }

  addDefaultPriceListInit(id: number, data: any) {
    const url = this.customersUriService.getAddDefaultPriceListInitUri(id)
    return this.http.post(url, data);
  }

  addDefaultPercentListInitSingle(id: number, data) {
    const url = this.customersUriService.getAddDefaultPercentListInitSingleUri(id)
    return this.http.post(url, data);

  }

  deleteDefaultPercentListInitSingle(listId: number, itemId: number) {
    const url = this.customersUriService.getDeleteDefaultPercentListInitSingleUri(listId, itemId)
    return this.http.delete(url);

  }

  addDefaultPriceListByPercentInit(id: number, data: any) {
    const url = this.customersUriService.getAddDefaultPriceListByPercentInitUri(id)
    return this.http.post(url, data);
  }

  deleteDefaultPriceList(id: number): Observable<DefaultPriceListItem> {
    const url = this.customersUriService.getDeleteDefaultPriceListUri(id);
    return this.http.delete<DefaultPriceListItem>(url)
  }

  updateDefaultPriceListName(id: number, data): Observable<any> {
    const url = this.customersUriService.getDefaultPriceListInfoUri(id);
    return this.http.put(url, data);
  }

  updateDefaultPriceListByPercentName(id: number, data): Observable<any> {
    const url = this.customersUriService.getDefaultPriceListByPercentInfoUri(id);
    return this.http.put(url, data);
  }

  getDefaultPercentUserExceptions(id: number, filters?): Observable<any> {
    const url = this.customersUriService.getDefaultPercentUserExceptionsUri(id);
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get(url, { params });
  }

  createDefaultPriceList(name: string): Observable<DefaultList> {
    let data = {
      title: name
    }
    const url = this.customersUriService.getCreateDefaultPriceListUri();

    return this.http.post<DefaultList>(url, data);
  }

  importDefaultFile(id, data): Observable<any> {
    const url = this.customersUriService.getImportDefaultFileUri(id);
    return this.http.post(url, data)
  }

  importDefaultFileByPercent(id, data): Observable<any> {
    const url = this.customersUriService.getImportDefaultFileByPercentUri(id);
    return this.http.post(url, data)
  }

  getAvailableCurrencies(): Observable<Currency[]> {
    const url = this.customersUriService.getAvailableCurrenciesUri();
    return this.http.get<Currency[]>(url);
  }

  getAvailableCategories() {
    const url = this.customersUriService.getCategoriesUri();
    return this.http.get<Category[]>(url);
  }

  assignCustomerPrice(price: Price): Observable<Price> {
    const url = this.customersUriService.getCustomerPriceUri();
    return this.http.post<Price>(url, price);
  }

  assignCustomerPercent(price: any): Observable<any> {
    const url = this.customersUriService.getCustomerPercentUri();
    return this.http.post<any>(url, price);
  }

  assignDefaultPrice(userId: number, defaultId: number): Observable<ExportPrice> {
    let data = {
      user: userId
    }
    const url = this.customersUriService.getAssignDefaultPriceUri(defaultId);
    return this.http.post<ExportPrice>(url, data)
  }

  assignDefaultLists(data): Observable<any> {
    const url = this.customersUriService.getAssignDefaultListsUri()
    return this.http.post(url, data);
  }

  assignDefaultPercent(userId: number, defaultId: number): Observable<any> {
    let data = {
      user: userId
    }
    const url = this.customersUriService.getAssignDefaultPercentUri(defaultId);
    return this.http.post<any>(url, data)
  }

  removeCustomerPrice(id: number): Observable<Price> {
    const url = this.customersUriService.getRemoveCustomerPrice(id);
    return this.http.delete<Price>(url);
  }

  removeCustomerPercent(id: number): Observable<Price> {
    const url = this.customersUriService.getRemoveCustomerPercent(id);
    return this.http.delete<Price>(url);
  }


  getCustomerFinanceSummary(id: number): Observable<CustomerFinanceSummary> {
    let params = new HttpParams();
    if (id) params = params.append('user', id.toString());

    const url = this.customersUriService.getCustomerFinanceSummaryUri();
    return this.http.get<CustomerFinanceSummary>(url, { params })
  }

  getUserWallet(filters?: walletFilters): Observable<WalletList> {
    let params = new HttpParams();
    for (let filter in filters) {
      params = params.append(filter, filters[filter])
    }

    const url = this.customersUriService.getUserWalletUri();
    return this.http.get<WalletList>(url, { params })
  }

  getUserWalletArchive(filters?: walletFilters): Observable<WalletList> {
    let params = new HttpParams();
    for (let filter in filters) {
      params = params.append(filter, filters[filter])
    }

    const url = this.customersUriService.getUserWalletArchiveUri();
    return this.http.get<WalletList>(url, { params })
  }

  getCascadeSellInvoiceItems(id: number, filters: CascadeSellInvoiceFilters): Observable<CascadeSellInvoiceItem[]> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.customersUriService.getCascadeSellInvoiceItemsUri(id);
    return this.http.get<CascadeSellInvoiceItem[]>(url, { params });
  }

  getCascadeSellInvoiceList(filters: any): Observable<CascadeSellInvoiceList> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.customersUriService.getCascadeSellInvoiceListUri();
    return this.http.get<CascadeSellInvoiceList>(url, { params });
  }

  getCascadeSellInvoiceDetails(id: number, filters: any) {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    const url = this.customersUriService.getCascadeSellInvoiceDetailsUri(id);
    return this.http.get<CascadeInvoice>(url, { params });
  }

  getCascadeInvoiceRelatedOrders(id: number, filters: any): Observable<InvoiceRelatedOrders> {
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter])
      }
    }

    const url = this.customersUriService.getCascadeInvoiceRelatedOrdersUri(id);
    return this.http.get<InvoiceRelatedOrders>(url, { params });
  }

  getCurrencies() {
    const url = this.customersUriService.getCurrenciesUri();
    return this.http.get<Currency[]>(url);
  }

  getAvailableShowingCurrencies() {
    let params = new HttpParams();
    params = params.append('show_display', '1');

    const url = this.customersUriService.getCurrenciesUri();
    return this.http.get<Currency[]>(url, { params });
  }

  getCurrency(id: number): Observable<Currency> {
    const url = this.customersUriService.getCurrencyUri(id);
    return this.http.get<Currency>(url);
  }

  addCredit(credit: Credit) {
    const url = this.customersUriService.getAddCreditUri();
    return this.http.post<Credit>(url, credit);
  }

  removeCredit(credit: Credit) {
    const url = this.customersUriService.getRemoveCreditUri();
    return this.http.post<Credit>(url, credit)
  }

  createUserPayment(payLoad: payLoad) {
    const url = this.customersUriService.getCreatUserPaymentUri();
    return this.http.post<payLoad>(url, payLoad);
  }

  updateInvoiceItemPrice(data: any, type: string): Observable<any> {
    let params = new HttpParams();
    params = params.append('type', type);

    const url = this.customersUriService.getUpdateInvoiceItemPriceUri();
    return this.http.post(url, data, { params });
  }

  getUserWalletStatistic(userId: number): Observable<WalletStatistic> {
    let params = new HttpParams();
    params = params.append('currency_id', userId.toString());

    const url = this.customersUriService.getUserWalletStatisticUri();
    return this.http.get<WalletStatistic>(url, { params });
  }

  createCustomer(data: CustomerRegister): Observable<CustomerRegister> {
    const url = this.customersUriService.getCustomersUri();
    return this.http.post<CustomerRegister>(url, data);
  }

  createCustomerByCode(data): Observable<CustomerRegisterByCode> {
    const url = this.customersUriService.getCreateCustomerByCodeUri();
    return this.http.post<CustomerRegisterByCode>(url, data)
  }

  createCustomerKYC(data): Observable<any> {
    const url = this.customersUriService.getCreateCustomerKYCUri();
    return this.http.post(url, data);
  }

  addCustomerShowingPrice(data: CustomerShowingPrice) {
    const url = this.customersUriService.getCustomersShowingPriceUri();
    return this.http.post(url, data);
  }

  deleteCustomerShowingPrice(id: number) {
    const url = this.customersUriService.getCustomerShowingPrice(id);
    return this.http.delete(url);
  }

  getUserProfileById(id: number): Observable<Profile> {
    const url = this.customersUriService.getUserProfileByIdUri(id);
    return this.http.get<Profile>(url);
  }

  enablePrintAccess(id: number, isAllow: boolean) {
    let data = {
      'print_access': isAllow
    }

    const url = this.customersUriService.getEnablePrintAccessUri(id);
    return this.http.put<any>(url, data);
  }

  changeUserState(id, data) {
    const url = this.customersUriService.getUserProfileByIdUri(id);
    return this.http.put<any>(url, data);
  }

  getCustomerProductList(filters): Observable<any> {
    let params = new HttpParams();

    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    const url = this.customersUriService.getCustomerProductListUri();
    return this.http.get<any>(url, { params });
  }

  getCustomerProductListMembers(id: number) {
    const url = this.customersUriService.getCustomerProductListMembersUri(id);
    return this.http.get(url);
  }

  deleteCustomerProductList(id: number): Observable<any> {
    const url = this.customersUriService.deleteCustomerProductListUri(id);
    return this.http.delete(url)
  }

  deleteCustomerProductListByPercent(id: number): Observable<any> {
    const url = this.customersUriService.deleteCustomerProductListByPercentUri(id);
    return this.http.delete(url)
  }


  getProductListActiveItems(id: number): Observable<any> {
    const url = this.customersUriService.getProductListActiveItemsUri(id);
    return this.http.get(url);
  }

  getProductListItems(limit: number = 25, offset: number = 0, query_params?): Observable<AssignedProductListResults> {
    let params = new HttpParams();

    params = params.append('limit', limit.toString());
    params = params.append('offset', offset.toString());

    for (let query in query_params) {
      if (query_params[query]) {
        params = params.append(query, query_params[query])
      }
    }

    const url = this.customersUriService.getProductListItemsUri();

    return this.http.get<AssignedProductListResults>(url, { params });

  }

  getProductListInfo(id): Observable<any> {
    const url = this.customersUriService.getProductListInfoUri(id);
    return this.http.get(url);
  }

  createCustomerProductList(title) {
    const url = this.customersUriService.getCreateCustomerProductListUri();
    return this.http.post(url, { title });
  }

  bulkAddItemsProductList(id, data) {
    const url = this.customersUriService.getProductListActiveItemsUri(id);
    return this.http.post(url, data);
  }

  updateCustomerProductList(id: number, data) {
    const url = this.customersUriService.getProductListInfoUri(id)
    return this.http.patch(url, data);
  }

  getPaymentMethods() {
    const url = this.customersUriService.getPaymentMethodsUri();
    return this.http.get(url);
  }

  getUserPaymentEmails(filters?) {
    let params = new HttpParams();

    for (let filter in filters) {

      if (filters[filter]) {
        params = params.append(filter, filters[filter])
      }
    }

    const url = this.customersUriService.getUserPaymentEmailsUri();
    return this.http.get(url, { params });
  }

  createUserPaymentEmail(emailObj): Observable<any> {
    const url = this.customersUriService.getUserPaymentEmailsUri();
    return this.http.post(url, emailObj);
  }

  editUserPaymentEmail(id: number, emailObj): Observable<any> {
    const url = this.customersUriService.getUserPaymentEmailEditUri(id);
    return this.http.put(url, emailObj)
  }

  removeUserPaymentEmail(id: number): Observable<any> {
    const url = this.customersUriService.getUserPaymentEmailEditUri(id);
    return this.http.delete(url);
  }

  getProductSuggestions(filters): Observable<ProductSuggestions> {
    let params = new HttpParams();

    for (let filter in filters) {

      if (filters[filter]) {
        params = params.append(filter, filters[filter])
      }
    }
    const url = this.customersUriService.getProductSuggestionsUri();
    return this.http.get<ProductSuggestions>(url, { params })
  }

  addDisplayPrice(obj: DisplayPrice): Observable<any> {
    const url = this.customersUriService.getAddDisplayPriceUri();
    return this.http.post(url, obj)
  }

  setShowingCurrency(currency): Observable<any> {
    const url = this.customersUriService.getUserProfileUri();
    return this.http.put(url, currency)
  }

  importDisplayPriceFile(data: any): Observable<any> {
    const url = this.customersUriService.getImportDisplayPriceFileUri();
    return this.http.post(url, data)
  }

  getSalesManagerList(filters): Observable<any> {
    const url = this.customersUriService.getSalesManagerListUri();
    let params = new HttpParams();
    for (const filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get(url, { params })
  }

  createSalesManager(data): Observable<any> {
    const url = this.customersUriService.getSalesManagerListUri();

    return this.http.post(url, data);
  }
  /* DEPRECATED */
  deleteSalesManager(id: number): Observable<any> {
    const url = this.customersUriService.getSalesManagerDetailUri(id);
    return this.http.delete(url);
  }

  activateSalesManager(id: number): Observable<any> {
    const url = this.customersUriService.getSalesManagerActivateUri(id);
    return this.http.post(url, {});
  }

  deactivateSalesManager(id: number): Observable<any> {
    const url = this.customersUriService.getSalesManagerDeactivateUri(id);
    return this.http.post(url, {});
  }

  getSalesManagerDetails(id: number): Observable<any> {
    const url = this.customersUriService.getSalesManagerDetailUri(id);
    return this.http.get(url);
  }

  updateSalesManager(id: number, data): Observable<any> {
    const url = this.customersUriService.getSalesManagerDetailUri(id);

    return this.http.patch(url, data);
  }

  assignSalesManagerToCustomer(id, data): Observable<any> {
    const url = this.customersUriService.assignSalesManagerToCustomerUri(id);
    return this.http.post(url, data);
  }

  getAssignedCustomersSalesManager(id: number): Observable<any> {
    const url = this.customersUriService.getAssignedCustomersSalesManagerUri(id);
    return this.http.get(url)
  }

  getSalesManagerReports(filters?): Observable<any> {
    const url = this.customersUriService.getSalesManagerReportsUri();
    let params = new HttpParams();

    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    return this.http.get(url, { params });
  }

  getSalesManagerGeneralReports(filters?): Observable<any> {
    const url = this.customersUriService.getSalesManagerGeneralReportsUri();
    let params = new HttpParams();

    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    return this.http.get(url, { params });
  }

  getSalesManagerDetailReports(filters?): Observable<any> {
    const url = this.customersUriService.getSalesManagerDetailReportsUri();
    let params = new HttpParams();

    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }

    return this.http.get(url, { params });
  }

  getUserDefaultPaymentList(filters, id?: number,): Observable<any> {
    const url = this.customersUriService.userDefaultPaymentListUri();
    let params = new HttpParams();

    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter])
      }
    }

    return this.http.get(url, { params })
  }

  createUserDefaultPaymentList(data): Observable<any> {
    const url = this.customersUriService.userDefaultPaymentListUri();
    return this.http.post(url, data)
  }

  deleteUserDefaultPaymentList(id: number): Observable<any> {
    const url = this.customersUriService.userDefaultPaymentListActionsUri(id);
    return this.http.delete(url);
  }

  updateUserDefaultPaymentList(id: number, data): Observable<any> {
    const url = this.customersUriService.userDefaultPaymentListActionsUri(id);
    return this.http.put(url, data)
  }

  getAssignedUsersDefaultPayment(id: number): Observable<any> {
    const url = this.customersUriService.getAssignedUsersDefaultPayment(id);
    return this.http.get(url);
  }

  assignUserDefaultPaymentList(id: number, userId: number): Observable<any> {
    let data = {
      user_id: userId
    }
    const url = this.customersUriService.assignUserDefaultPaymentListUri(id);
    return this.http.post(url, data)
  }

  removeAssignUserDefaultPaymentList(id: number, userId: number): Observable<any> {
    let data = {
      user_id: userId
    }

    const url = this.customersUriService.assignUserDefaultPaymentListUri(id);
    return this.http.request('delete', url, { body: data })
  }

  getGateways(): Observable<any> {
    const url = this.customersUriService.getGatewaysUri();
    return this.http.get(url)
  }


  getUserDefaultPaymentListDetails(id: number) {
    const url = this.customersUriService.userDefaultPaymentListActionsUri(id);
    return this.http.get(url);
  }

  getMyMerchants(filters: PaginationFilter): Observable<MyMerchantList> {
    const url = this.customersUriService.getMyMerchantsUri();
    let params = new HttpParams();
    for (let filter in filters) {
      if (filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<MyMerchantList>(url, { params })
  }

  selectCurrentCompany(company_id: number): Observable<Login> {
    const url = this.customersUriService.getSelectCurrentCompanyUri(company_id);
    return this.http.put<Login>(url, undefined)
  }

  setAssignPercentException(data: any): Observable<any> {
    const url = this.customersUriService.setAssignPercentException();
    return this.http.post<any>(url, data);
  }

  downloadAssignMap(filters: any): Observable<any> {
    const url = this.customersUriService.getAssignPercentExcel();
    let params = new HttpParams();
    for(let filter in filters) {
      if(filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get<Blob>(url, {params, responseType: 'blob' as 'json'});
  }

  getCustomerKycDetail(seller_id: number): Observable<any> {
    const url = this.customersUriService.getCustomerKycDetail(seller_id);
    return this.http.get<any>(url)
  }

  defaultPriceListExcelBulkUpdate(data: any): Observable<any> {
    const url = this.customersUriService.defaultPriceListExcelBulkUpdate();
    return this.http.post<any>(url, data)
  }

  updateProductInMultiplePriceList(data: any): Observable<any> {
    const url = this.customersUriService.updateProductInMultiplePriceList();
    return this.http.post<any>(url, data)
  }
  
  getDefaultPriceListItemExport(id: any): Observable<Blob> {
    const url = this.customersUriService.getDefaultPriceListItemExport(id);
    return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
  }

    exportPriceListItemExcelFile(id): Observable<Blob> {
    const url = this.customersUriService.exportPriceListItemExcelFile(id);

    return this.http.get<Blob>(url, {
      responseType: 'blob' as 'json'
    })
  }

  exportCustomerDefaultAssignItems(id): Observable<Blob> {
    const url = this.customersUriService.exportCustomerDefaultAssignItems(id);

    return this.http.get<Blob>(url, {
      responseType: 'blob' as 'json'
    })
  }

  exportDefaultAssignPriceItems(id): Observable<Blob> {
    const url = this.customersUriService.exportDefaultAssignPriceItems(id);

    return this.http.get<Blob>(url, {
      responseType: 'blob' as 'json'
    })
  }

  getDefaultAssignPriceListItems(id: number, filters: any): Observable<any> {
    const url = this.customersUriService.getDefaultAssignPriceListItemsUri(id);
      let params = new HttpParams();
    for(let filter in filters) {
      if(filters[filter]) {
        params = params.append(filter, filters[filter]);
      }
    }
    return this.http.get(url, { params });
  }
}
